export default "__VITE_ASSET__ComBmgcP__"